'use client';

export const Banner = () => {
    return (
        <div style={{ width: '100%', lineHeight: 0 }}>
            {/* eslint-disable-next-line @next/next/no-img-element */}
            <img
                src="/images/banner-1.png"
                alt="Ennix Electronics smart home banner"
                fetchPriority="high"
                loading="eager"
                style={{ width: '100%', height: 'auto', display: 'block' }}
            />
        </div>
    );
};
